<template lang="pug"> 
  v-btn( 
    :disabled='loading || disabled'
    :loading='loading'
    :color="colorDefault"
    :block="block"
    :dark="!loading"
    depressed 
    rounded
    style="padding:0 3px; min-width:30px;"
    @click='$emit("click")'
  ) 
    slot

</template>
<script>
import ButtonMixin from '@/mixins/Button'
export default {
  mixins : [ButtonMixin],
  computed: {
    colorDefault () {
      return this.color || 'var(--bg-main-color)'
    }
  }
}
</script>